import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../common";
import { get } from "jquery";
import { IApiResponse, IPaginate } from "../../../interfaces/common";
import { IAnteNata, IAntenatalStat } from "../../../interfaces/antenatal";

export const antenatalApi = createApi({
    reducerPath: "antenatal",
    baseQuery: baseQuery,
    tagTypes: ["Antenatal", "AntenatalList"],
    endpoints: (builder) => ({
        getAntenatalStatistics: builder.query<IApiResponse<IAntenatalStat>,
            {
                period: "month" | "year" | "week"
            }>({
                query: ({ period }) => `antenatal/stats?period=${period}`,
                providesTags: (result, error, { period }) => [{ type: "Antenatal" }],
            }),
        getAntenatalList: builder.query<IApiResponse<IPaginate<IAnteNata[]>>,
            {
                registrationDateStart: string,
                registrationDateEnd: string,
                eddStart: string,
                eddEnd: string,
                billingMethod: string,
                hospitalPatientId: string,
                patientName: string,
                hospitalId: string,
                status: string,
                page: number;
                limit: number
                pagination: { page?: number; limit?: number },
                searchTerm?: string,
            }>({
                query:
                    ({ hospitalId, status, pagination: { page = 1, limit = 10 }, searchTerm, }) => `antenatal?hospitalId=${hospitalId}&status=${status}&page=${page}&limit=${limit}`,
                providesTags: [{ type: "AntenatalList", id: "LIST" }],
            }),
        getAntenatalDataList: builder.query<IApiResponse<IPaginate<IAnteNata[]>>, {
            registrationDateStart?: string,
            registrationDateEnd?: string,
            completionDateStart?: string,
            completionDateEnd?: string,
            eddStart?: string,
            eddEnd?: string,
            billingMethod?: string,
            hospitalPatientId?: string,
            patientName?: string,
            hospitalId?: string,
            status?: string,
            pagination: { page?: number; limit?: number },
            searchTerm?: string,
        }>({
            query: ({
                hospitalId,
                status,
                pagination: { page = 1, limit = 10 },
                searchTerm,
                registrationDateStart,
                registrationDateEnd,
                eddStart,
                eddEnd,
                completionDateStart,
                completionDateEnd,
                billingMethod,
                hospitalPatientId,
                patientName
            }) => {
                const params = [`page=${page}`, `limit=${limit}`];

                if (hospitalId) params.push(`hospitalId=${encodeURIComponent(hospitalId)}`);
                if (status) params.push(`status=${encodeURIComponent(status.trim())}`);
                if (searchTerm) params.push(`searchTerm=${encodeURIComponent(searchTerm)}`);
                if (registrationDateStart) params.push(`registrationDateStart=${encodeURIComponent(registrationDateStart)}`);
                if (registrationDateEnd) params.push(`registrationDateEnd=${encodeURIComponent(registrationDateEnd)}`);
                if (eddStart) params.push(`eddStart=${encodeURIComponent(eddStart)}`);
                if (eddEnd) params.push(`eddEnd=${encodeURIComponent(eddEnd)}`);
                if (completionDateStart) params.push(`completionDateStart=${encodeURIComponent(completionDateStart)}`);
                if (completionDateEnd) params.push(`completionDateEnd=${encodeURIComponent(completionDateEnd)}`);
                if (billingMethod) params.push(`billingMethod=${encodeURIComponent(billingMethod)}`);
                if (hospitalPatientId) params.push(`hospitalPatientId=${encodeURIComponent(hospitalPatientId)}`);
                if (patientName) params.push(`patientName=${encodeURIComponent(patientName)}`);

                return `antenatal?${params.join('&')}`;
            },
            providesTags: [{ type: "AntenatalList", id: "LIST" }],
        }),

        getAntenatalInLabour: builder.query<IApiResponse<IPaginate<IAnteNata[]>>, {pagination: { page?: number; limit?: number },
        eddFrom?: string, eddTo?: string, labourStartFrom?: string, labourStartTo?: string, registrationFrom?: string, registrationTo?: string, billingMethod?: string }>({

            query: ({ pagination: { page = 1, limit = 10 }, eddFrom, eddTo, labourStartFrom, labourStartTo, registrationFrom, registrationTo, billingMethod }) => `/antenatal/in-labour?page=${page}&limit=${limit}${eddFrom ? `&eddFrom=${eddFrom}` : ''}${eddTo ? `&eddTo=${eddTo}` : ''}${labourStartFrom ? `&labourStartFrom=${labourStartFrom}` : ''}${labourStartTo ? `&labourStartTo=${labourStartTo}` : ''}${registrationFrom ? `&registrationFrom=${registrationFrom}` : ''}${registrationTo ? `&registrationTo=${registrationTo}` : ''}${billingMethod ? `&billingMethod=${billingMethod}` : ''}`,
            providesTags: [{ type: "AntenatalList", id: "LIST" }],
        }),

        getAntenatalById: builder.query<IApiResponse<any>, string>({
            query: (id) => `antenatal/${id}`,
            providesTags: (result, error, id) => [{ type: "Antenatal", id }],
        }),
    })
});
export const {
    useGetAntenatalStatisticsQuery,
    useGetAntenatalListQuery,
    useGetAntenatalDataListQuery,
    useGetAntenatalInLabourQuery,
    useGetAntenatalByIdQuery
} = antenatalApi;